import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import useProviderDeadlineGroup from '@hooks/useProviderDeadlineGroup'
import useProviderDeadlineGroups from '@hooks/useProviderDeadlineGroups'

import ProviderDeadlineGroupListItem from './ProviderDeadlineGroupListItem'

const ProviderDeadlineGroups = (props) => {
  const { providerId } = props

  const providerDeadlineGroupsPayload = useProviderDeadlineGroups({
    filters: { provider_id: providerId },
    performHttpRequests: !!providerId,
  })

  const {
    filteredProviderDeadlineGroups,
    hasFilteredProviderDeadlineGroups,
    loading,
  } = providerDeadlineGroupsPayload

  const {
    callbacks: {
      createOrEditProviderDeadlineGroup,
    },
  } = useProviderDeadlineGroup({ provider_id: providerId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="Deadline Groups"
    >

      <DashboardModule.ScrollableSection>
        {!loading && filteredProviderDeadlineGroups.map(providerDeadlineGroup => (
          <ProviderDeadlineGroupListItem
            key={providerDeadlineGroup.id}
            providerDeadlineGroup={providerDeadlineGroup}
          />
        ))}
      </DashboardModule.ScrollableSection>

      {!loading && !hasFilteredProviderDeadlineGroups && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Deadline Groups Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Please add a Deadline Group below.
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
        <DashboardModule.FooterRight>
          <Button
            buttonStyle="secondaryEdit"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={() => createOrEditProviderDeadlineGroup()}
            size={['medium', 'small']}
            width={['100%', 'fit-content']}
          >
            Add Deadline
          </Button>
        </DashboardModule.FooterRight>
      </DashboardModule.Footer>
    </DashboardModule>
  )
}

ProviderDeadlineGroups.propTypes = {
  providerId: PropTypes.number.isRequired,
}

export default ProviderDeadlineGroups
